import { useQuery } from "react-query";
import { LocalizationService } from "../services/AppLocalizationService";
import { getCurrentLanguage } from "../components/Utils";
import { PersistantStorage } from "../Utils/LocalStorage";
import { MdmsService } from "../services/MDMS";

export const useLocalizationStore = ({
  stateCode,
  moduleCode,
  language,
  isAgentUser = false,
}) => {
  return useQuery(
    ["DfsWebstore", stateCode, moduleCode, language],
    async () => {
      let moduleCodes = [];
      if (
        Array.isArray(moduleCode) && moduleCode.length > 0 &&
        (/^(dfs|dfsweb)-schemes$/.test(moduleCode[0]) || moduleCode[0]?.startsWith("SCHEME"))
      )
        moduleCodes = moduleCode;
      else if (typeof moduleCode !== "string")
        moduleCode?.forEach((code) => {
          if (code) moduleCodes.push(`dfsweb-${code.toLowerCase()}`);
        });
      const LocalePromise = LocalizationService.getLocale({
        modules:
          typeof moduleCode == "string"
            ? ["dfs-grm-tech-support", "dfs-grm", "rainmaker-hcm-dss", "dfs-scheme-remarks"].includes(
              moduleCode
            )
              ? [moduleCode]
              : [`dfsweb-${moduleCode.toLowerCase()}`]
            : moduleCodes,
        locale: language,
        tenantId: stateCode,
      });
      await LocalePromise;
      return {};
    },
    // Keeps isLoading false across a language switch (language is in the key) so
    // callers gating a mount on it don't unmount and lose local UI state.
    { enabled: !isAgentUser, keepPreviousData: true }
  );
};

export const useInitStore = () => {
  const stateCode = "br";
  const currentLanguage = getCurrentLanguage();
  if (currentLanguage === null) {
    PersistantStorage.set("WebApp.Employee.locale", "hi_IN");
  }
  return useQuery(
    ["DfsWebInitStore", stateCode],
    async () => {
      const mdmsResponse = await MdmsService.getInitData(stateCode);

      // Both generations in one request: the dfsweb-* copies do not exist on QA yet (2026-09-22), so the
      // dfs-* modules keep Hindi alive; once a dfsweb-* module is created its messages load alongside.
      const LocalePromise = LocalizationService.getLocale({
        modules: [
          `dfsweb-common`,
          `dfs-schemes`, `dfs-appliedSchemes`, `dfs-hortiServices`, `dfs-helpSection`,
          `dfsweb-schemes`, `dfsweb-appliedSchemes`, `dfsweb-horti`, `dfsweb-helpSection`,
        ],
        locale: currentLanguage || "hi_IN",
        tenantId: stateCode,
      });
      await LocalePromise;

      const releaseInfo =
        mdmsResponse?.["common-masters"]?.ReleaseInfo?.[0] || {};
      const seedSubSchemes =
        mdmsResponse["seed-sub-schemes-en"]?.SeedSubSchemes || {};
      const intiData = {
        releaseInfo,
        seedSubSchemes,
      };
      return intiData;
    },
    {
      staleTime: Infinity,
    }
  );
};
